import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { Layout, Card, Breadcrumb, Row, Icon, Tabs, Spin, Select, Button } from 'antd';
import { HorizontalBar } from 'react-chartjs-2';
// Others
import { strings } from '../../localization';
import { ROUTE_NAMES } from '../../utils';
import MeterSelectBox from '../common/MeterSelectBox';
import { fetchAllMeters } from '../../data/meters/actions';
import { setLastPreselectedMeter, setLastPreselectedDevice, setLastPreselectedPeriod } from '../../data/app/actions';
import { getMetersListSorted } from '../../data/meters/selectors';
import { getUserId, isRoleAdministrator } from '../../data/auth/selectors';
import { getPreselectedMeterId, selectedLangageSelector, getPreselectedDeviceId, getPreselectedPeriodId } from '../../data/app/selector';
import { fetchAllDevices } from '../../data/devices/actions';
import { getDeviceList } from '../../data/devices/selectors';
import { getTotalKwh, onMonitoringIsLoading, getDeviceConsumption } from '../../data/monitoring/actions';
import { fetchSavingPotentials } from '../../data/reports/actions';
import { getSavingPotentialsList, getSavingPotentialsIsLoading } from '../../data/reports/selectors';
import { getMonitoringIsLoading } from '../../data/monitoring/selectors';
import { fetchHistoricalEventsForDevice } from '../../data/training/actions';
import { getHistoricalList, getHistoricalEventsIsLoading } from '../../data/training/selectors';

const { TabPane } = Tabs;

class Reports extends React.Component {

    savingPotentialsKwhOptions = {
        maintainAspectRatio: false,
        aspectRatio: 2,
        legend: {
            display: true
        },
        scales: {
            xAxes: [{
                type: 'logarithmic',
                ticks: {
                    beginAtZero: true,
                    callback: value => `${Math.round(value * 100) / 100} {strings.reports.kwh}`
                }
            }]
        },
        layout: {
            padding: {
                left: 5,
                right: 5,
                top: 5,
                bottom: 5
            }
        },
        elements: {
            rectangle: {
                backgroundColor: context => {
                    const rec = context.dataset.data[context.dataIndex];
                    if(rec && rec.avg && rec.x > rec.avg)
                        return '#ff3645';
                    return '#0e8220';
                }
            }
        }
    };

    savingPotentialsWOptions = {
        maintainAspectRatio: false,
        aspectRatio: 2,
        legend: {
            display: true
        },
        scales: {
            xAxes: [{
                type: 'logarithmic',
                ticks: {
                    beginAtZero: true,
                    callback: value => `${Math.round(value * 100) / 100} ${strings.training.wattUnit}`
                }
            }]
        },
        layout: {
            padding: {
                left: 5,
                right: 5,
                top: 5,
                bottom: 5
            }
        },
        elements: {
            rectangle: {
                backgroundColor: context => {
                    const rec = context.dataset.data[context.dataIndex];
                    if(rec && rec.avg && rec.x > rec.avg)
                        return '#ff3645';
                    return '#0e8220';
                }
            }
        }
    };

    constructor(props){
        super(props);
        this.state = {
            selectedMeter: null,
            activeTab: '0'
        };
        this.months = null;
        this.max = 1;
        this.kwhCost = 0;
        this.alwaysOnConsumption = null;
        this.deviceConsumption = null;
    }

    componentWillMount() {
        const { fetchAllMeters, metersData } = this.props;
        if(!metersData){
            fetchAllMeters();
        }else{
            this.selectMeter(this.props);
        }
    }

    componentWillReceiveProps(nextProps) {
        this.selectMeter(nextProps);
    }

    selectMeter = (props) => {
        const { selectedMeter } = this.state;
        const { userId, metersData, preselectedMeterId, fetchAllDevices, deviceList } = props;
        // const devs = deviceList && deviceList.length > 0 && deviceList.filter(item => !item.deleted);
        if (
            (selectedMeter === null) &&
            metersData &&
            metersData.size > 0 &&
            userId !== undefined
        ) {
            let meterId =  metersData.get(0).get('id');
            if (preselectedMeterId >= 0) {
                meterId = preselectedMeterId;
            } else {
                const { setLastPreselectedMeter } = this.props;
                setLastPreselectedMeter(meterId);
            }
            fetchAllDevices(meterId, true);
            this.loadYearlyReport(meterId);
            this.setState(() => ({
                selectedMeter: meterId
            }));
        }
    };

    handleMeterChange = id => {
        const { setLastPreselectedMeter, fetchAllDevices, fetchSavingPotentials } = this.props;
        const { activeTab } = this.state;
        setLastPreselectedMeter(id);
        fetchAllDevices(id, true);
        this.loadYearlyReport(id);
        this.setState(() => ({
            selectedMeter: id
        }));
        setTimeout(() => this.loadDevReport(), 2000);
        if(activeTab === '2')fetchSavingPotentials(id);
    };

    loadDevReport = () => {
        const { selectedDevice } = this.props;
        this.handleChangeDevice(selectedDevice);
    };

    loadYearlyReport = meterId => {
        if(this.months === null) {
            const dt = new Date();
            this.months = this.generateMonths(dt.getFullYear(), dt.getMonth());
        }
        this.kwhCost = this.getKwhCost();
        this.max = 1;
        const { onMonitoringIsLoading } = this.props;
        onMonitoringIsLoading(true);
        this.loadKwh(meterId, 1);
    };

    loadKwh = (meterId, idx) => {
        if(idx < this.months.length)
        {
            const { getTotalKwh } = this.props;
            getTotalKwh(meterId, this.months[idx].fromTs, this.months[idx].toTs).then(res => {
                const val = res ? Math.floor(res) : 0;
                this.months[idx].kwh = val;
                if(val > this.max) this.max = val;
                this.loadKwh(meterId,idx + 1);
            });
        } else {
            // console.log(this.months);
            this.loadDevConsumption(meterId, this.months[1].fromTs, this.months[1].toTs);
        }
    };

    loadDevConsumption = (meterId, from, to) => {
        const { getDeviceConsumption } = this.props;
        getDeviceConsumption(meterId, from, to, true).then(res => {
            this.alwaysOnConsumption = res;
            getDeviceConsumption(meterId, from, to, false).then(res => {
                this.deviceConsumption = res;
                const { onMonitoringIsLoading } = this.props;
                onMonitoringIsLoading(false);
                this.loadDevReport();
            });
        });
    };

    generateMonths = (year, month) => {
        const months = [];
        const m = moment([year, month]);
        for(let i = 0; i < 14; i += 1){
            months.push({
                name: `${m.format('MMMM')} ${m.year()}`,
                fromTs: m.startOf('month').valueOf() - 3600000,
                toTs: m.endOf('month').valueOf() - 3600000,
                monthName: m.format('MMMM'),
                shortMonthName: m.format('MMM'),
                kwh: 0,
                year: m.year()
            });
            m.subtract(1, 'month');
        }
        return months;
    };

    handleChangeDevice = dev => {
        const { selectedMeter } = this.state;
        const { setLastPreselectedDevice, selectedPeriod } = this.props;
        if(selectedMeter !== null && this.months){
            const { fetchHistoricalEventsForDevice } = this.props;
            fetchHistoricalEventsForDevice(dev, this.months[selectedPeriod].fromTs, this.months[selectedPeriod].toTs);
        }
        setLastPreselectedDevice(dev);
    };

    handlePeriodDevice = id => {
        const { selectedMeter } = this.state;
        const { setLastPreselectedPeriod, selectedDevice } = this.props;
        if(selectedMeter !== null && this.months){
            const { fetchHistoricalEventsForDevice } = this.props;
            fetchHistoricalEventsForDevice(selectedDevice, this.months[id].fromTs, this.months[id].toTs);
        }
        setLastPreselectedPeriod(id);
    };

    getKwhCost = () => {
        const { selectedMeter } = this.state;
        const { metersData } = this.props;
        if(!metersData) return 0;
        const meters = metersData.toJS();
        const meter = meters.filter(item => item.meter === selectedMeter);
        return meter && meter.length > 0 ? meter[0].home.kwhCost : 0;
    };

    render() {
        this.kwhCost = this.getKwhCost();
        const reduced = this.months ? ((this.months[2].kwh < 1 || this.months[1].kwh < 1) ? 0 : Math.round((this.months[1].kwh - this.months[2].kwh) * 1000.0 / this.months[2].kwh) / 10) : 0;
        const {
            selectedMeter,
            activeTab
        } = this.state;
        const {
            metersData,
            isAdmin,
            isLoading,
            deviceList,
            historicalListIsLoading,
            historicalList,
            selectedDevice,
            selectedPeriod,
            savingPotentialsIsLoading,
            savingPotentials
        } = this.props;

        const kwhData = {
            labels: savingPotentials.map(item => item.name),
            datasets: [{
                label: strings.reports.myAvgKwh,
                maxBarThickness: 30,
                data: savingPotentials.map(item => ({x: Math.round(item.myAvgKwh * 100) / 100, avg: item.avgKwh}))
            },{
                label: strings.reports.avgKwh,
                backgroundColor: '#046aff',
                maxBarThickness: 30,
                data: savingPotentials.map(item => [Math.round((item.minKwh < 0 ? 0 : item.minKwh) * 100) / 100, Math.round(item.maxKwh * 100) / 100])
            }]
        };

        const wData = {
            labels: savingPotentials.map(item => item.name),
            datasets: [{
                label: strings.reports.myAvgW,
                maxBarThickness: 30,
                data: savingPotentials.map(item => ({x: Math.round(item.myAvgW * 100) / 100, avg: item.avgW}))
            },{
                label: strings.reports.avgW,
                backgroundColor: '#046aff',
                maxBarThickness: 30,
                data: savingPotentials.map(item => [Math.round((item.minW < 0 ? 0 : item.minW) * 100) / 100, Math.round(item.maxW * 100) / 100])
            }]
        };

        const selectedDev = deviceList && deviceList.filter(item => item.device === selectedDevice);
        return (
            <Layout key="training-content">
                <Layout.Content style={{ padding: '10px' }}>
                    <Card style={{ marginBottom: '30px' }}>
                        <h2 data-testid="headline">{strings.reports.route}</h2>
                        <Breadcrumb separator=">">
                            <Breadcrumb.Item>{strings.appName}</Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <Link to={ROUTE_NAMES.TRAIN}>
                                    <Icon type="deployment-unit" />
                                    &nbsp;
                                    {strings.reports.route}
                                </Link>
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </Card>
                    <Card style={{ marginBottom: '30px' }}>
                        <span>
                          <MeterSelectBox
                              meterChange={this.handleMeterChange}
                              selectedMeter={selectedMeter}
                              metersData={metersData}
                              isAdmin={isAdmin}
                          />
                        </span>
                    </Card>
                    <Row>
                        <Row>
                            <Tabs
                                defaultActiveKey={activeTab}
                                size="large"
                                tabBarGutter={30}
                                tabBarStyle={{ marginBottom: 0 }}
                                onChange={tabId => {
                                    if(tabId === '2'){
                                        const {fetchSavingPotentials} = this.props;
                                        fetchSavingPotentials(selectedMeter);
                                    }
                                    this.setState({activeTab: tabId});
                                }}
                            >
                                <TabPane
                                    key="0"
                                    tab={
                                        <span>
                                        <Icon type="bar-chart"/>
                                            {strings.reports.overAll}
                                        </span>
                                    }
                                >
                                    <Spin spinning={isLoading} size="large">
                                        <div style={{
                                            maxWidth: 1000,
                                            minHeight: 400,
                                            padding: '2em',
                                            margin: 'auto'
                                        }}>

                                            { this.months && !isLoading &&
                                                <>
                                                    <h4 style={{textAlign: 'center' }}>{strings.reports.reportTitle}<strong>{this.months[1].name}</strong></h4>
                                                    <h2 style={{textAlign: 'center' }}>{strings.reports.compare}</h2>
                                                    {
                                                        this.kwhCost === 0 && <p style={{color: '#B00', textAlign: 'center'}}>{strings.reports.kwhMissing}</p>
                                                    }
                                                    <svg className="compare" viewBox="0,0,400,80">
                                                        <path transform="translate(170, 10)"
                                                              d="M 22.410518,0 V 14.027049 H 0 V 44.133222 H 22.410518 V 58.159755 L 54.179639,29.079877 Z"
                                                              style={ reduced > 0 ? {fill: '#FF6600'} : {fill: '#4CAF50'}}/>
                                                        <g className="title">
                                                            <text x="92" y="11">{this.months[2].name}</text>
                                                            <text x="300" y="11">{this.months[1].name}</text>
                                                        </g>
                                                        <g className="consumtion">
                                                            <text x="92" y="32">{this.months[2].kwh} {strings.dashboard.kwhUnit}</text>
                                                            <text x="300" y="32">{this.months[1].kwh} {strings.dashboard.kwhUnit}</text>
                                                        </g>
                                                        <g className="cost">
                                                            <text x="92" y="50">{Math.round(this.months[2].kwh * this.kwhCost * 100) / 100} {strings.dashboard.costUnit}</text>
                                                            <text x="300" y="50">{Math.round(this.months[1].kwh * this.kwhCost * 100) / 100} {strings.dashboard.costUnit}</text>
                                                            <text x="300" y="65"
                                                                  style={ reduced > 0 ? {fill: '#FF6600'} : {fill: '#4CAF50'}}>{reduced === 0 ? '' : `${reduced > 0 ? '+' : ''}${reduced} %`}</text>
                                                        </g>
                                                    </svg>
                                                    <h2 style={{textAlign: 'center' }}>{strings.reports.monthlyConsumption}</h2>
                                                    <svg className="yearly" viewBox="0,0,500,280">
                                                        <line x1="0" y1="252" x2="500" y2="252" style={{stroke:'rgb(0,0,0)',strokeWidth:1}} />
                                                        {
                                                            this.months.map((item, i) => {
                                                                if(i === 0) return null;
                                                                const height = Math.round(item.kwh * 230.0 / this.max);
                                                                return <rect key={item.fromTs} x={(13 - i) * 37 + 14} y={250 - height} width="28" height={height} style={i===0 ? {fill: '#F60'} : {} } />
                                                            })
                                                        }
                                                        <g x="0" y="0" className="titles">
                                                            {
                                                                this.months.map((item, i) => i === 0 ? null : <text key={item.fromTs} x={(13 - i) * 37 + 28} y="271">{item.shortMonthName}</text>)
                                                            }
                                                        </g>
                                                        <g x="0" y="0" className="prices">
                                                            {
                                                                this.months.map((item, i) => i === 0 ? null : <text key={item.fromTs} x={(13 - i) * 37 + 28} y="260">{(Math.round(item.kwh * this.kwhCost * 100.0) / 100.0)} {strings.reports.euro}</text>)
                                                            }
                                                        </g>
                                                        <g x="0" y="0" className="values">
                                                            {
                                                                this.months.map((item, i) => {
                                                                    if(i === 0) return null;
                                                                    const height = Math.round(item.kwh * 230.0 / this.max);
                                                                    return <text key={item.fromTs} x={(13 - i) * 37 + 28} y={247 - height}>{item.kwh}</text>
                                                                })
                                                            }
                                                        </g>
                                                    </svg>
                                                    <br />
                                                    <br />
                                                    <br />
                                                    {
                                                        this.deviceConsumption && this.deviceConsumption.length > 0 &&
                                                        <>
                                                            <h2 style={{textAlign: 'center' }}>{strings.reports.mostRelevant}</h2>
                                                            <svg className="devices" viewBox="0,0,1000,120">
                                                                <g transform="translate(20, 0)">
                                                                    <path
                                                                        d="M 44.078964,5.9178925e-5 A 44.223212,44.223212 0 0 0 0,44.223204 44.223212,44.223212 0 0 0 44.223659,88.446344 44.223212,44.223212 0 0 0 88.446797,44.223204 44.223212,44.223212 0 0 0 44.223659,5.9178925e-5 a 44.223212,44.223212 0 0 0 -0.144695,0 z M 51.771518,10.613883 44.616399,38.953754 62.6184,41.019774 31.779974,75.936514 41.466203,48.527844 24.518919,47.815224 Z"
                                                                        style={{fill: '#aaa'}}/>
                                                                    <text x="100" y="25">{this.deviceConsumption[0].name}</text>
                                                                    <text x="100" y="50">{Math.round(this.deviceConsumption[0].watt / 10) / 100} {strings.reports.kwh}</text>
                                                                    <text x="100" y="75">{Math.round(this.deviceConsumption[0].watt * 10 / this.months[1].kwh) / 100} %</text>
                                                                </g>
                                                                <g transform="translate(320, 0)">
                                                                    <path
                                                                        d="M 44.078964,5.9178925e-5 A 44.223212,44.223212 0 0 0 0,44.223204 44.223212,44.223212 0 0 0 44.223659,88.446344 44.223212,44.223212 0 0 0 88.446797,44.223204 44.223212,44.223212 0 0 0 44.223659,5.9178925e-5 a 44.223212,44.223212 0 0 0 -0.144695,0 z M 51.771518,10.613883 44.616399,38.953754 62.6184,41.019774 31.779974,75.936514 41.466203,48.527844 24.518919,47.815224 Z"
                                                                        style={{fill: '#aaa'}}/>
                                                                    <text x="100" y="25">{this.deviceConsumption.length > 1 ? (this.deviceConsumption[1].name) : '-'}</text>
                                                                    <text x="100" y="50">{this.deviceConsumption.length > 1 ? (Math.round(this.deviceConsumption[1].watt / 10) / 100) : '-'} {strings.reports.kwh}</text>
                                                                    <text x="100" y="75">{this.deviceConsumption.length > 1 ? (Math.round(this.deviceConsumption[1].watt * 10 / this.months[1].kwh) / 100) : '-'} %</text>
                                                                </g>
                                                                <g transform="translate(620, 0)">
                                                                    <path
                                                                        d="M 44.078964,5.9178925e-5 A 44.223212,44.223212 0 0 0 0,44.223204 44.223212,44.223212 0 0 0 44.223659,88.446344 44.223212,44.223212 0 0 0 88.446797,44.223204 44.223212,44.223212 0 0 0 44.223659,5.9178925e-5 a 44.223212,44.223212 0 0 0 -0.144695,0 z M 51.771518,10.613883 44.616399,38.953754 62.6184,41.019774 31.779974,75.936514 41.466203,48.527844 24.518919,47.815224 Z"
                                                                        style={{fill: '#aaa'}}/>
                                                                    <text x="100" y="25">{strings.reports.alwaysOn}</text>
                                                                    <text x="100" y="50">{this.alwaysOnConsumption && this.alwaysOnConsumption.length > 0 ? (Math.round(this.alwaysOnConsumption[0].watt / 10) / 100) : '-'} {strings.reports.kwh}</text>
                                                                    <text x="100" y="75">{this.alwaysOnConsumption && this.alwaysOnConsumption.length > 0 ? (Math.round(this.alwaysOnConsumption[0].watt * 10 / this.months[1].kwh) / 100) : '-'} %</text>
                                                                </g>
                                                            </svg>
                                                        </>
                                                    }
                                                </>
                                            }
                                        </div>
                                    </Spin>
                                </TabPane>
                                <TabPane
                                    key="1"
                                    tab={
                                        <span>
                                        <Icon type="pie-chart"/>
                                            {strings.reports.byDevice}
                                        </span>
                                    }
                                >
                                    <Spin spinning={historicalListIsLoading} size="large">
                                        <div style={{
                                            maxWidth: 1200,
                                            minHeight: 400,
                                            padding: '2em',
                                            margin: 'auto'
                                        }}>

                                            { this.months && deviceList && !historicalListIsLoading && selectedDev && selectedDev.length > 0 &&
                                            <>
                                                <h2 style={{textAlign: 'center' }}>
                                                <span>{strings.reports.deviceReport}</span>
                                                <span>
                                                    <Select
                                                        onChange={this.handleChangeDevice}
                                                        value={selectedDevice}
                                                        dropdownMatchSelectWidth={false}
                                                        style={{
                                                            minWidth: '130px',
                                                            margin: '0 8px'
                                                        }}
                                                    >
                                                        {deviceList &&
                                                        deviceList.filter(item => !item.deleted).map(item => (
                                                            <Select.Option value={item.id} key={item.id}>
                                                                {item.name}
                                                            </Select.Option>
                                                        ))}
                                                    </Select>
                                                </span>
                                                <span>&gt;</span>
                                                <span>
                                                    <Select
                                                        onChange={this.handlePeriodDevice}
                                                        value={selectedPeriod}
                                                        dropdownMatchSelectWidth={false}
                                                        style={{
                                                            minWidth: '130px',
                                                            margin: '0 8px'
                                                        }}
                                                    >
                                                        {this.months &&
                                                        this.months.map((item, i) => (
                                                            <Select.Option value={i} key={item.fromTs}>
                                                                {item.name}
                                                            </Select.Option>
                                                        ))}
                                                    </Select>
                                                </span>
                                            </h2>

                                                <br />
                                                <svg className="onOff" viewBox="0,0,1000,500">
                                                    <line x1="5" y1="20" x2="995" y2="20" style={{stroke:'rgb(0,0,0)', strokeWidth:1}} />
                                                    <line x1="50" y1="20" x2="50" y2="500" style={{stroke:'rgb(0,0,0)', strokeWidth:1}} />

                                                    <line x1="50" y1="170" x2="995" y2="170" style={{stroke:'rgb(0,0,0,0.1)', strokeWidth:1}} />
                                                    <line x1="50" y1="320" x2="995" y2="320" style={{stroke:'rgb(0,0,0,0.1)', strokeWidth:1}} />
                                                    <line x1="50" y1="470" x2="995" y2="470" style={{stroke:'rgb(0,0,0,0.1)', strokeWidth:1}} />

                                                    <line x1="292" y1="20" x2="292" y2="500" style={{stroke:'rgb(0,0,0,0.1)', strokeWidth:1}} />
                                                    <line x1="524" y1="20" x2="524" y2="500" style={{stroke:'rgb(0,0,0,0.1)', strokeWidth:1}} />
                                                    <line x1="756" y1="20" x2="756" y2="500" style={{stroke:'rgb(0,0,0,0.1)', strokeWidth:1}} />

                                                        <g className="bars">
                                                            {
                                                                historicalList && historicalList.map(item => {
                                                                    const { id, duration } = item;
                                                                    const onDay = Math.floor((id - this.months[selectedPeriod].fromTs) / 86400000);
                                                                    const offDay = Math.floor((id - this.months[selectedPeriod].fromTs + duration) / 86400000);
                                                                    const start = 60 + ((id - this.months[selectedPeriod].fromTs) % 86400000) * 930 / 86400000;
                                                                    let end = 60 + ((id - this.months[selectedPeriod].fromTs + duration) % 86400000) * 930 / 86400000;
                                                                    if(onDay !== offDay) end = 990;
                                                                    const y = onDay * 15 + 35;

                                                                    return <line key={`${id}_${duration}`} x1={start} y1={y} x2={end} y2={y} strokeLinecap="round" />
                                                                })
                                                            }
                                                        </g>
                                                    <text x="100" y="15">00:00</text>
                                                    <text x="292" y="15">06:00</text>
                                                    <text x="524" y="15">12:00</text>
                                                    <text x="756" y="15">18:00</text>
                                                    <text x="950" y="15">24:00</text>
                                                    <g className="days">
                                                        <text x="45" y="38">1st</text>
                                                        <text x="45" y="173">10th</text>
                                                        <text x="45" y="323">20th</text>
                                                        <text x="45" y="473">30th</text>
                                                    </g>
                                                </svg>
                                                <br />
                                                <br />
                                                <br />
                                                <h3 style={{textAlign: 'center', color: '#860'}}>{strings.reports.graphTips}</h3>
                                                <br />
                                                <br />
                                                <br />
                                            </>
                                            }
                                        </div>
                                    </Spin>
                                </TabPane>
                                <TabPane
                                    key="2"
                                    tab={
                                        <span>
                                        <Icon type="fall"/>
                                            {strings.reports.savingPotentials}
                                        </span>
                                    }
                                >
                                    <Spin spinning={savingPotentialsIsLoading} size="large">
                                        <div style={{
                                            maxWidth: 1200,
                                            minHeight: 400,
                                            padding: '2em',
                                            margin: 'auto'
                                        }}>
                                            <div ref={this.dragBox}
                                                 style={{
                                                     height: 700
                                                 }}>
                                                <HorizontalBar options={this.savingPotentialsWOptions} data={wData} />
                                            </div>
                                            <br />
                                            <br />
                                            <div ref={this.dragBox}
                                                 style={{
                                                     height: 700
                                                 }}>
                                                <HorizontalBar options={this.savingPotentialsKwhOptions} data={kwhData} />
                                            </div>
                                        </div>
                                    </Spin>
                                </TabPane>
                            </Tabs>
                        </Row>
                    </Row>
                </Layout.Content>
            </Layout>
        );
    }
}

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        metersData: getMetersListSorted(state),
        userId: getUserId(state),
        preselectedMeterId: getPreselectedMeterId(state),
        isAdmin: isRoleAdministrator(state),
        deviceList: getDeviceList(state),
        lang: selectedLangageSelector(state),
        isLoading: getMonitoringIsLoading(state),
        historicalList: getHistoricalList(state),
        historicalListIsLoading: getHistoricalEventsIsLoading(state),
        selectedDevice: getPreselectedDeviceId(state),
        selectedPeriod: getPreselectedPeriodId(state),
        savingPotentialsIsLoading: getSavingPotentialsIsLoading(state),
        savingPotentials: getSavingPotentialsList(state)
    }),
    {
        fetchAllMeters,
        setLastPreselectedMeter,
        fetchAllDevices,
        getTotalKwh,
        onMonitoringIsLoading,
        getDeviceConsumption,
        fetchHistoricalEventsForDevice,
        setLastPreselectedPeriod,
        setLastPreselectedDevice,
        fetchSavingPotentials
    }
)(Reports);